import { CellProcessor } from './preprocessors/cell-processor'
import { fast_calc } from './preprocessors/fast_calc'
import { fast_productionPlanShelf } from './preprocessors/fast_productionPlanShelf';

export const preprocessors:{[key:string]:CellProcessor} = {
  fast_calc: fast_calc,
  fast_productionPlanShelf: fast_productionPlanShelf,
}


// WEBPACK FOOTER //
// ./src/widgets/spread_sheet/spread-sheet/preprocessors.ts